import React, { useState } from "react";
import styled from "styled-components";
import { MantineAccordion, Alert } from "components/bootstrap";
import { Row } from "common/components";
import { SelectedRowsProvider } from "common/contexts";
import { BulkStepActionButton } from "security-app/components/Investigations/Details/ProceduresSegment/Procedures/ProcedureStepEvents/row-actions";
import ProcedureStepEvents from "security-app/components/Investigations/Details/ProceduresSegment/Procedures/ProcedureStepEvents";
import DescriptionCell from "security-app/components/SecurityEvents/EventProcedures/DescriptionCell";
const DescriptionWrapper = styled(Row)`
  width: auto%;

  & > div {
    width: 100%;
  }
`;
function StepLabel({ step, procedure, order }) {
  return /* @__PURE__ */ React.createElement(Row, { $align: "flex-start", style: { paddingRight: "0.5rem" } }, /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "sm", $width: "22%", style: { flexShrink: 0 } }, /* @__PURE__ */ React.createElement("span", null, `Step ${order}`)), /* @__PURE__ */ React.createElement(DescriptionWrapper, { $width: "auto", $align: "center", $gap: "sm" }, /* @__PURE__ */ React.createElement(DescriptionCell, { mdValue: step.description, noExpand: true })), /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "sm", $width: "auto", style: { float: "right", marginLeft: "auto" } }, step.action && /* @__PURE__ */ React.createElement(BulkStepActionButton, { step, eventIds: procedure.event_ids || [], labelFor: "stepLabel" })));
}
function Steps({ procedure }) {
  var _a, _b, _c;
  const [openedBody, setOpenedBody] = useState((_b = (_a = procedure.steps) == null ? void 0 : _a[0]) == null ? void 0 : _b.id);
  const steps = (procedure.steps || []).map((step, index) => ({
    value: step.id,
    label: /* @__PURE__ */ React.createElement(StepLabel, { step, procedure, order: index + 1 }),
    content: /* @__PURE__ */ React.createElement(ProcedureStepEvents, { procedureId: procedure.id, step, isOpened: openedBody === step.id })
  }));
  if (steps.length === 0) return /* @__PURE__ */ React.createElement(Alert, null, "This procedure doesn't have any steps");
  return /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(
    MantineAccordion,
    {
      variant: "separated",
      chevronPosition: "left",
      accordionItems: steps,
      defaultValue: (_c = steps[0]) == null ? void 0 : _c.value,
      value: openedBody,
      onChange: (value) => setOpenedBody(value)
    }
  ));
}
export default Steps;
